"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const events_1 = require("events");
const dispatcher_1 = require("../dispatcher");
class GlobalStore extends events_1.EventEmitter {
    constructor() {
        super();
        this.languages = [];
        this.apiResources = {
            host: "",
        };
        this.account = {};
        this.notifications = [];
        this.visibleStealthBlockNames = [];
    }
    registerAccountInformation(userId, authStr) {
        this.account.userid = userId;
        this.account.authstr = authStr;
    }
    getAccountId() {
        return this.account.userid != undefined ? this.account.userid : null;
    }
    getAccountAuthString() {
        return this.account.authstr != undefined ? this.account.authstr : null;
    }
    getNotifications() {
        return this.notifications;
    }
    stealthBlockIsvisible(name) {
        return this.visibleStealthBlockNames.indexOf(name) >= 0;
    }
    getHost() {
        return this.apiResources.host;
    }
    getLanguages() {
        return this.languages;
    }
    getI18n() {
        return this.i18n;
    }
    getLocale() {
        return this.locale;
    }
    updateLocaleLanguage() {
        this.languages.forEach(l => {
            if (l.getDescriptor().toLowerCase() === this.locale) {
                this.localeLanguage = l;
            }
        });
    }
    getLocaleLanguage() {
        if (this.localeLanguage === undefined)
            this.updateLocaleLanguage();
        return this.localeLanguage;
    }
    /**
     * Database text
     * Get text in chosen locale from given MultiLanguageString.
     * @param multiLanguageString
     */
    dt(multiLanguageString) {
        try {
            if (this.getLocaleLanguage() === undefined)
                return multiLanguageString.getLanguages()[0].getValue();
            const specificLanguageString = multiLanguageString.getLanguage(this.getLocaleLanguage().getIdentifier());
            if (specificLanguageString === null) {
                const defaultValue = multiLanguageString.getLanguages()[0].getValue();
                console.warn("Couldn't find a translation for", "\"" + defaultValue + "\"", "in locale", "\"" + this.locale + "\"", multiLanguageString);
                return defaultValue;
            }
            else {
                return specificLanguageString.getValue();
            }
        }
        catch (e) {
            console.error("Couldn't find any translations in locale", "\"" + this.locale + "\"", "for", multiLanguageString);
            return "";
        }
    }
    handleAction(action) {
        switch (action.type) {
            case "SIGN_IN": {
                this.registerAccountInformation(action.userId, action.authStr);
                this.emit("change");
                break;
            }
            case "NOTIFICATION": {
                var key = this.notifications.length + "-" + Date.now();
                let nType = "danger";
                if (action.nType !== undefined) {
                    nType = action.nType;
                }
                this.notifications.push({
                    key,
                    nType: nType,
                    title: action.title,
                    message: action.message
                });
                this.emit("change");
                setTimeout(() => {
                    var i = 0;
                    while (i < this.notifications.length) {
                        if (this.notifications[i].key == key) {
                            this.notifications.splice(i, 1);
                        }
                        i++;
                    }
                    ;
                    this.emit("change");
                }, 3000);
                console.log(action.title, action.message);
                break;
            }
            case "SHOW_STEALTH_BLOCK": {
                if (!this.stealthBlockIsvisible(action.name)) {
                    this.visibleStealthBlockNames.push(action.name);
                }
                this.emit("change");
                break;
            }
            case "HIDE_STEALTH_BLOCK": {
                if (this.stealthBlockIsvisible(action.name)) {
                    this.visibleStealthBlockNames.splice(this.visibleStealthBlockNames.indexOf(action.name), 1);
                }
                this.emit("change");
                break;
            }
            case "SET_API_HOST": {
                this.apiResources.host = action.host;
                this.emit("change");
                break;
            }
            case "RETRIEVE_ALL_LANGUAGES": {
                this.languages = action.languages;
                this.emit("change");
                break;
            }
            case "CHANGE_LOCALE": {
                this.i18n = action.i18n;
                const locale = this.i18n.load(action.locale);
                this.locale = locale;
                this.updateLocaleLanguage();
                this.emit("change");
                break;
            }
        }
    }
}
const globalStore = new GlobalStore();
exports.default = globalStore;
exports.dt = globalStore.dt.bind(globalStore);
dispatcher_1.default.register(globalStore.handleAction.bind(globalStore));
//# sourceMappingURL=GlobalStore.js.map